import { LegalDocumentConfig } from "../../components/legal-document-viewer/types";

export const termsOfUse: LegalDocumentConfig = {
  intro: {
    title: "Terms of Use and Conditions",
    description: [
      `Please read these Terms and Conditions carefully before using www.homedesignguild.com operated by HOME DESIGN GUILD, LLC (“the Company”)`,
    ],
  },
  conditions: {
    title: "Conditions of use",
    description: [
      `As a condition of your use of the Company’s website, you represent and warrant that you
will not use the website for any purpose that is unlawful, immoral, or prohibited by these
terms, conditions, and notices. If you do not agree and accept without modification the
notices, terms and conditions set forth herein, do not use the website. Other than these
Terms and Conditions between you and the Company relating to the sale of products or
services to you through the website, the Company will not enter into any agreement with
you or create any obligation to you through this website and no attempt to create such an
agreement or obligation will be effective.`,
    ],
  },

  privacyPolicy: {
    title: "Privacy policy",
    description: [
      `We take our commitment to protect your privacy seriously. Your use of the website is subject
to our privacy policy. Please review the policy for more on how we collect and use
information.`,
    ],
  },

  ageRestriction: {
    title: "Age restriction",
    description: [
      `You must be at least eighteen (18) years of age before you can use this website. By using
this website, you warrant that you are at least eighteen (18) years of age, and you may
legally adhere to this Agreement. The Company assumes no responsibility for liabilities
related to age misrepresentation.`,
    ],
  },

  accountSetup: {
    title: "Account setup",
    description: [
      `Access to certain functionalities of the Company will require you to sign up and create an
account with the Company. If you create an account, you agree to provide us with accurate
information and update your information, including updating the email address associated
with your account, as needed for accuracy and notification. The Company will treat personal
information you provide as part of creating an account in accordance with our Privacy
Policy. Additional account requirements, including verification of your account details, may
apply depending on your use of the Company’s website.`,
    ],
  },

  intellectualProperty: {
    title: " Intellectual property",
    description: [
      `The service marks, information, and opinions (“Intellectual Property”) used and displayed
on this website are the Intellectual Property of Company. Nothing on this website should
be construed as granting, by implication, estoppel or otherwise, any license or right to use
any Intellectual Property displayed on the Company’s website, without the prior written
permission of the Company. Company aggressively enforces its Intellectual Property rights
to the fullest extent of the law. The name of the Company, or any of its product names, logo,
information, or opinion derivatives may not be used in any way, including in advertising or
publicity pertaining to distribution of materials on this website, without prior, written
permission from Company. Company strictly prohibits use of the Company logo as part of
a link to or from any website unless establishment of such a link is approved in advance by
Company in writing. Fair use of Company’s Intellectual Property requires proper
acknowledgment. Other product and company names mentioned on this website may be
the Intellectual Property of their respective owners.`,
    ],
  },

  yourContent: {
    title: "Your Content",
    description: [
      {
        title: `Defining “Your Content”`,
        description: [
          `The Company website enables you to post, input, upload, or otherwise submit materials,
including without limitation photos, floor plans, reviews, feedback (as explained below),
profile pictures, ideabooks, videos, messages, comments and/or forms. You may also post
reviews of professionals, third-party service providers, third-party products, merchants, or
third-party services, as well as input content into certain Automated Tools (“Input”). All
materials that you post on the Company website or otherwise provide to Company,
including the Input of Automated Tools, as defined, will be referred to collectively as “Your
Content.” “Input” is the text, images, audio, or other content provided and/or uploaded to
Automated Tools.`,
        ],
      },
      {
        title: "Permission to use Your Content",
        description: [
          `You hereby grant to the Company and our affiliates, licensees, and sublicensees, without
compensation to you or others, license (including the right to sublicense through multiple
tiers) to use, reproduce, process, adapt, publicly perform, publicly display, modify, prepare
derivative works, store, publish, transmit, and distribute Your Content, or any portion
thereof, throughout the world in any format, media, or distribution method (whether now
known or hereafter created) for the duration Your Content is displayed on the Company’s
website. Once Your Content is no longer available on the Company’s website, social media,
and any/all other platforms, the Company will not use Your Content in any way, shape, or
form, but retains the ability to do so at its discretion.`,
        ],
      },
      {
        title: "Ownership",
        description: [
          `The Company acknowledges and agrees that you, or your licensors, as applicable, retain
ownership of any and all copyrights in Your Content, subject to the non-exclusive rights
granted to the Company in the paragraph above, and that no ownership of such copyrights
is transferred to the Company under this Agreement. Further, with respect to Your Content
in the form of photos, and subject to Company product and user experience considerations:
(i) the Company will use commercially reasonable efforts to maintain the attribution of such
photos as submitted by you, and (ii) the Company will not license or sublicense to third
parties individual photos or collections of photos, except for Company Business Purposes.
“Company Business Purposes” means any use in connection with a Company-branded or
co-branded website, application, publication, or service, or any use that advertises, markets,
or promotes the Company website, the services, or the information it contains, the
Company, or its affiliates. Company Business Purposes specifically include the use of Your
Content on the Company website in connection with features and functions offered by the
Company to its users that enable them to view and interact with Your Content (such as
Designer Files, Designer Bios and Designer Confessions).`,
        ],
      },
      {
        title: "Your responsibility for Your Content",
        description: [
          `By posting, uploading, inputting, or submitting Your Content on the Company website, you
represent and warrant to the Company that you have the ownership rights or have obtained
all necessary licenses or permissions from any relevant parties to use Your Content in this
manner. This includes obtaining the right to grant the Company the rights to use Your
Content in accordance with this Agreement. You are in the best position to judge whether
Your Content is in violation of the Intellectual Property or personal rights of any third party.
You accept full responsibility for avoiding infringement of the Intellectual Property or
personal rights of others in connection with Your Content. You agree to pay all royalties,
fees, and any other monies owed to any person, individual, or entity by reason of Your
Content.`,
        ],
      },
      {
        title: "Moderation",
        description: [
          `The Company reserves the right to remove Your Content, in whole or part, for any reason
(which may include a reported violation of Copyright, Trademark, or other rights) without
notice. This includes removing Your Content that encompasses copyright, trademark, or
other Intellectual Property misappropriation, unlawful conduct, harassment, or other illegal
content, as defined under applicable law and regulations. The Company does not guarantee
that it will publish or remove all Your Content. Certain content, such as reviews, videos, and discussion comments, may be flagged for human review before publication on the
Company website based on automated technology.`,
        ],
      },
    ],
  },

  companyContent: {
    title: "The Company’s content",
    description: [
      {
        title: `Defining “Our Content”`,
        description: [
          `All Intellectual Property, as described above, in or related to the Company website
(specifically including, but not limited to, our software, the Company marks, the Company
logo, and Company buttons, badges, and widgets, but excluding Your Content), is the
property of the Company, its subsidiaries and affiliates, or its licensors (“Our Content and
Materials”).`,
        ],
      },
      {
        title: "User License",
        description: [
          `Subject to these Terms and Conditions, including the restrictions below, the Company
grants you a limited, non-exclusive license to use and access Our Content and Materials in
connection with your use of the Company website. Except as expressly agreed to otherwise
by the Company (such as your eligibility for the creation of a professional profile or your
entering into a seller, vendor, advertiser, trade, or any other agreement with the Company),
your use of the Company website must be limited to personal, non-commercial use. The
Company may terminate this license at any time for any reason. Except for the rights and
license granted in these terms, the Company reserves all other rights and grants no other
rights or licenses, implied or otherwise.`,
        ],
      },
      {
        title: "Restrictions",
        description: [
          `Except as expressly provided in these Terms or agreed to by the Company, you agree not
to use, modify, reproduce, distribute, sell, license, reverse engineer, decompile, or
otherwise exploit Our Content and Materials without the Company's express written
permission. This includes the use of Our Content and Materials, and the use of content
posted to the Company website by our users, in connection with the development of any
software program, including, but not limited to, training a machine learning, artificial
intelligence, or other automated tools system, without the Company's permission. The
Company's permission for your use of the Company website expressly excludes commercial
use by you of any information concerning product descriptions or professional listings for
the benefit of another merchant. You are expressly prohibited from any use of data mining,
robots, scraping, or similar data gathering and extraction tools in your use of the Company
website. You may view and print a reasonable number of copies of web pages located on
the Company website for your own personal use, provided that you retain all proprietary
notices contained in the original materials, including attribution to the Company.`,
        ],
      },
      {
        title: "Ownership",
        description: [
          `You acknowledge and agree that the Company website and Company marks will remain the
property of the Company. The content, information, and services made available on the
Company website are protected by U.S. and international copyright, trademark, and other
laws, and you acknowledge that these rights are valid and enforceable. You acknowledge
that you do not acquire any ownership rights by using the Company website and the further
understanding that: (i) your use of such buttons, links, and widgets links only to the
Company website; (ii) you will not modify such buttons, links, widgets, or associated code in
any manner; (iii) you will not use any such buttons, links, or widgets in any manner that
implies or suggests that the Company endorses, sponsors, or recommends the website on
which such buttons, links, and widgets are used; and (iv) the use of such buttons, links, and
widgets, and the website on which such buttons, links, and widgets are used, do not violate
the Company's Acceptable Use Policy or Prohibited Products Policy.`,
        ],
      },
    ],
  },

  thirdPartyLinks: {
    title: "Links to Third Party Website",
    description: [
      `This website may contain links to websites owned or operated by parties other than
Company or its affiliates. Such links are provided for your reference only. The Company
does not control outside websites and is not responsible for their content. The Company’s
inclusion of links to an outside website does not imply any endorsement of the material on
the website or, unless expressly disclosed otherwise, any sponsorship, affiliation or
association with its owner, operator or sponsor, nor does the inclusion of the links imply
that Company is authorized to use any trade name, trademark, logo, legal or official seal or
copyrighted symbol that may be reflected in the linked website.`,
    ],
  },

  userAccounts: {
    title: "User accounts",
    description: [
      `As a user of this website, you may be asked to register with us and provide private
information. You are responsible for ensuring the accuracy of this information, and you are
responsible for maintaining the safety and security of your identifying information. You are
also responsible for all activities that occur under your account or password.`,
    ],
  },

  applicableLaw: {
    title: "Applicable law",
    description: [
      `By using this website, you agree that the laws of the State of Alabama without regard to
principles of conflict laws, will govern these terms and conditions, or any dispute of any sort
that might come between Company and you, or its business partners and associates.`,
    ],
  },

  disputes: {
    title: "Disputes",
    description: [
      `ANY CLAIM, DISPUTE OR CONTROVERSY ARISING OUT OF, RELATING TO OR CONCERNING
THIS WEBSITE AND/OR THESE TERMS AND CONDITIONS SHALL BE DECIDED BY BINDING
ARBITRATION IN ACCORDANCE WITH THE RULES OF THE AMERICAN ARBITRATION
ASSOCIATION AND ANY SUCH ARBITRATION PROCEEDINGS SHALL BE BROUGHT AND HELD
IN LEEDS COUNTY, ALABAMA. CLAIMS MAY ONLY BE BROUGHT IN YOUR INDIVIDUAL
CAPACITY AND NOT AS A PURPORTED REPRESENTATIVE OF ANY CLASS. THE DECISIONS OF
THE ARBITRATORS SHALL BE BINDING AND CONCLUSIVE UPON ALL PARTIES INVOLVED
AND JUDGMENT UPON ANY AWARD OF THE ARBITRATORS MAY BE ENTERED BY ANY COURT
HAVING COMPETENT JURISDICTION. THIS PROVISION SHALL BE SPECIFICALLY
ENFORCEABLE IN ANY COURT OF COMPETENT JURISDICTION. ANY ARBITRATION SHALL BE
LIMITED TO THE AMOUNT YOU ACTUALLY SPENT IN CONNECTION WITH THE PRODUCTS
AND/OR SERVICES PROVIDED BY THE COMPANY.`,
    ],
  },

  indemnification: {
    title: "Indemnification",
    description: [
      `You agree to indemnify and hold Company (including, but not limited to: its officers,
directors, agents, subsidiaries, joint ventures, employees and third-party service providers),
harmless from all claims, demands, and damages of every kind and nature, known and
unknown including reasonable attorneys' fees, arising out of a breach of your
representations and warranties set forth above, or your violation of any law or the rights of
a third party.`,
    ],
  },

  liabilityLimitation: {
    title: "Limitation on liability",
    description: [
      `Company is not liable for any damages that may occur to you because of your misuse of
our website. Company reserves the right to edit, modify, and change these Terms and
Conditions at any time. These Terms and Conditions are an understanding between
Company and the user, and this supersedes and replaces all prior agreements regarding
the use of this website.`,
      `By interacting in any nature within the platform, you agree to be bound by the Terms and
Conditions outlined above.`,
    ],
  },
};

// {
//     title: "",
//     description: [
//         "",
//     ]
// }
